<template>
    <div class="user-rebate-level">
        <el-tabs type="border-card" v-model="currentTab">
            <el-tab-pane label="导航设置" name="basic">
                <el-row class="section">
                    <el-col :span="24">
                        <el-alert
                                title="温馨提示"
                                type="success"
                                close-text="知道了"
                                show-icon>
                            <p>导航图标支持3种不同类型：</p>
                            <p>1、点击跳转本小程序页面，appId不用填写，只要写图片地址和页面路径</p>
                            <p>2、点击跳转到其它小程序，appId,图片地址，页面路径都要写，appId请联系要跳转的小程序获取</p>
                            <p>3、点击跳转到小程序关联的公众号文章，只需要设置图片地址和网页链接</p>
                            <p>支持单独替换导航图标，要替换第几个就设置第几个，其它留空</p>
                            <p>设置的时候，请注意选择淘宝，拼多多和京东，不要设置错了</p>
                            <p>火车票，充话费，电影票可以参考教程：<a href="https://www.yuque.com/yifakeji/irpssl/xx5g46" target="_blank">火车票、电影票、充话费教程</a></p>
                            <p><a href="https://www.yuque.com/yifakeji/irpssl/hhpo44" target="_blank"
                                  style="color: #ff0036">不懂设置点我看教程</a></p>
                        </el-alert>
                    </el-col>
                </el-row>

                <el-row class="section">
                    <el-col :span="24">
                        <el-form ref="form" label-width="200px" label-position="left">
                            <el-form-item label="选择平台:">
                                <el-row>
                                    <el-col :span="12">
                                        <el-select class="form-item" v-model="type" placeholder="请选择平台">
                                            <el-option
                                                    v-for="item in channelTypes"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-form-item label="是否开启自定义导航:">
                                <el-row>
                                    <el-col :span="12">
                                        <el-switch v-model="iconCustom" @change="changeSwitch"></el-switch>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                            <el-row v-for="(item,index) in icons.icons">
                                <el-col :span="24" class="row-header">
                                    <el-col class="row-item-label">
                                        {{'第'+(index+1)+'个导航'}}
                                    </el-col>
                                    <el-col :span="12">
                                        <el-button class="opt" type="primary" size="small"
                                                   @click="addRule(index)">加一个
                                        </el-button>
                                        <el-button class="opt" type="danger" size="small"
                                                   @click="deleteRule(index)">
                                            删一个
                                        </el-button>
                                        <el-button size="mini" type="primary"
                                                   @click.prevent="moveUp(index)">上移
                                        </el-button>
                                        <el-button size="mini" type="primary"
                                                   @click.prevent="moveDown(index)">下移
                                        </el-button>
                                        <el-button size="mini" type="success"
                                                   @click.prevent="moveToTop(index)">
                                            置顶
                                        </el-button>

                                    </el-col>
                                </el-col>
                                <el-col :span="24" class="row-item">
                                    <el-col class="row-item-label">
                                        导航名称
                                    </el-col>
                                    <el-col :span="12">
                                        <el-input v-model="item.iconName"></el-input>
                                    </el-col>
                                </el-col>
                                <el-col :span="24" class="row-item">
                                    <el-col class="row-item-label">
                                        导航图标地址
                                    </el-col>
                                    <el-col :span="12">
                                        <el-input v-model="item.iconImg"></el-input>
                                    </el-col>
                                </el-col>
                                <el-col :span="24" class="row-item">
                                    <el-col class="row-item-label">
                                        导航页面路径
                                    </el-col>
                                    <el-col :span="12">
                                        <el-input v-model="item.pagePath"></el-input>
                                    </el-col>
                                </el-col>
                                <el-col :span="24" class="row-item">
                                    <el-col class="row-item-label">
                                        导航appId
                                    </el-col>
                                    <el-col :span="12">
                                        <el-input v-model="item.appId"></el-input>
                                    </el-col>
                                </el-col>
                                <el-col :span="24" class="row-item">
                                    <el-col class="row-item-label">
                                        网页链接
                                    </el-col>
                                    <el-col :span="12">
                                        <el-input v-model="item.webUrl"></el-input>
                                    </el-col>
                                </el-col>
                            </el-row>
                            <el-form-item>
                                <el-button type="primary" size="medium" @click="loadDemoSettings">加载默认设置</el-button>
                                <el-button type="primary" size="medium" @click="onSubmit">保存</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>

            </el-tab-pane>
        </el-tabs>


    </div>

</template>
<script>
    import {navSettingsApi} from "../../common/navSettingsApi";

    export default {
        name: "index",
        components: {
            promotion: require('./promotion').default,
        },
        watch: {
            type(newValue, oldValue) {
                this.load()
            },
            iconCustom(newValue, oldValue) {

            }

        },
        created() {
        },
        mounted() {


        },
        data() {
            return {
                channelTypes: [
                    {
                        name: '淘宝',
                        id: "TAOBAO"
                    },
                    {
                        name: '拼多多',
                        id: "PDD"
                    },
                    {
                        name: '京东',
                        id: "JD"
                    }
                ],
                iconCustom: false,
                icons: {},
                labelPosition: 'left',
                type: 'TAOBAO',
                item: {
                    texts: [{text: ''}]
                },
                currentTab: 'basic'
            }
        },
        created() {
            this.load()

        },
        methods: {
            moveUp(index) {
                var that = this
                if (index - 1 >= 0) {
                    var indexItem = this.icons.icons[index]
                    var lastItem = this.icons.icons[index - 1]
                    this.icons.icons[index] = lastItem
                    this.icons.icons[index - 1] = indexItem
                    that.$forceUpdate();
                } else {
                    that.failMsg("已经是第一个了")
                }
            },
            moveDown(index) {
                var that = this
                if ((index + 1) < this.icons.icons.length) {
                    var indexItem = this.icons.icons[index]
                    var nextItem = this.icons.icons[index + 1]
                    this.icons.icons[index] = nextItem
                    this.icons.icons[index + 1] = indexItem
                    that.$forceUpdate();
                } else {
                    that.failMsg("已经是最后个了")
                }
            },
            moveToTop(index) {
                let indexItem = this.icons.icons[index];
                this.icons.icons.splice(index, 1)
                this.icons.icons.splice(0, 0, indexItem)
                this.$forceUpdate()
            },
            changeSwitch() {
                var that = this;
                navSettingsApi.navCustom.call(this, {type: this.type, custom: this.iconCustom}, function (res) {
                    if (that.iconCustom) {
                        that.successMsg("开启成功")
                    } else {
                        that.successMsg("关闭成功")
                    }
                })
            },
            load() {
                var that = this;
                navSettingsApi.getNavSettings.call(that, {type: that.type}, function (res) {
                    that.iconCustom = res.result.iconCustom
                    var icons = {
                        icons: [
                            {
                                iconName: "",
                                iconImg: "",
                                pagePath: "",
                                appId: "",
                                webUrl: ""
                            },
                            {
                                iconName: "",
                                iconImg: "",
                                pagePath: "",
                                appId: "",
                                webUrl: ""
                            },
                            {
                                iconName: "",
                                iconImg: "",
                                pagePath: "",
                                appId: "",
                                webUrl: ""
                            },
                            {
                                iconName: "",
                                iconImg: "",
                                pagePath: "",
                                appId: "",
                                webUrl: ""
                            },
                            {
                                iconName: "",
                                iconImg: "",
                                pagePath: "",
                                appId: "",
                                webUrl: ""
                            }
                        ]
                    }
                    if (!res.result.nav) {
                        that.icons = icons;
                    } else {
                        that.icons = JSON.parse(res.result.nav)
                        if (!that.icons || that.icons.icons.length == 0) {
                            that.icons = icons;
                        }
                    }
                })
            },
            loadDemoSettings() {
                var that = this
                navSettingsApi.getDemoNavSettings.call(that, {type: that.type}, function (res) {
                    if (res.result.nav) {
                        that.successMsg("加载成功")
                        that.icons = JSON.parse(res.result.nav)
                    } else {
                        that.failMsg("加载失败")
                    }
                })

            },
            initRule() {
                if (!this.item.texts || this.item.texts.length == 0) {
                    this.item.texts = [{text: ''}]
                }

            },
            addRule(index) {
                if (!this.icons.icons) {
                    this.icons.icons = []
                }
                this.icons.icons.splice(index + 1, 0, {
                    iconName: "",
                    iconImg: "",
                    pagePath: "",
                    appId: "",
                    webUrl: ""
                });
                this.$forceUpdate()
            },
            deleteRule(index) {
                this.icons.icons.splice(index, 1)
                this.$forceUpdate()
            },
            onSubmit() {
                var that = this;
                let icons = this.icons.icons;
                for (var i = 0; i < icons.length; i++) {
                    let iconItem = icons[i];
                    if (this.isEmpty(iconItem.iconImg)) {
                        this.failMsg("第" + (i + 1) + "个导航图片地址不能为空");
                        return
                    }
                    if (this.isEmpty(iconItem.iconName)) {
                        this.failMsg("第" + (i + 1) + "个导航名称不能为空");
                        return
                    }
                    if (!this.isEmpty(iconItem.appId) && this.isEmpty(iconItem.pagePath)) {
                        this.failMsg("第" + (i + 1) + "个导航页面路径和appid必须同时设置或者都不设置");
                        return
                    }
                }
                navSettingsApi.createOrUpdateConfig.call(that, {
                    type: that.type,
                    icons: JSON.stringify(that.icons)
                })
            },
        }
    }

</script>
<style lang="scss">

    .user-rebate-level {
        text-align: left;

        .row-header {
            font-size: 14px;
            color: #606266;
            border-top: 1px solid #eee;
            padding: 20px 0px;
            margin-bottom: 5px;
        }

        .row-item {
            font-size: 14px;
            color: #606266;
            margin: 5px 0;
        }

        .row-item-label {
            width: 200px;
        }


        .rules {
            margin-bottom: 10px;
        }

        .line {
            text-align: center;
        }


        .head-tip {
            margin-left: 10px;
            color: #ff0036;
        }

        .tip {
            color: #409EFF;
            font-weight: 500;
        }


        .title {
            margin-left: 10px;
            display: flex;
            align-items: center;

            .trigger {
                margin-left: 20px;
            }

            strong {
                color: $hover-color;
            }

        }

        .el-collapse {
            border: none;
        }

        .el-collapse-item__wrap {
            border: none;
        }


        .el-collapse-item__content {
            padding-bottom: 0px;
        }
    }

</style>